import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import type { ScheduleStatus } from '@/types/api'

export const SCHEDULE_STATUS_META: Record<ScheduleStatus, { label: string; variant: 'success' | 'default' | 'outline' | 'secondary' | 'warning' | 'offline'; hint: string }> = {
  active: { label: 'Active now', variant: 'success', hint: 'Inside its time window right now (organization time).' },
  scheduled: { label: 'Scheduled', variant: 'default', hint: 'Recurring — outside its window right now.' },
  future: { label: 'Upcoming', variant: 'outline', hint: 'Starts on a later date.' },
  expired: { label: 'Expired', variant: 'secondary', hint: 'Its end date or validity has passed.' },
  paused: { label: 'Paused', variant: 'warning', hint: 'Its campaign isn’t running (draft, paused, archived or outside its dates).' },
  disabled: { label: 'Disabled', variant: 'offline', hint: 'Turned off — it never plays.' },
}

/** Approximate status in the organization's zone; the per-display simulator is exact. */
export function ScheduleStatusBadge({ status }: { status: ScheduleStatus }) {
  const meta = SCHEDULE_STATUS_META[status] ?? SCHEDULE_STATUS_META.scheduled
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant={meta.variant}>{meta.label}</Badge>
      </TooltipTrigger>
      <TooltipContent>{meta.hint}</TooltipContent>
    </Tooltip>
  )
}
